import * as React from 'react'

import Svg, {
  ClipPath,
  Defs,
  G,
  Path,
  RadialGradient,
  Rect,
  Stop,
} from 'react-native-svg'

const CardSVG = ({ ...props }) => {
  return (
    <Svg
      width={49}
      height={48}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <G clipPath="url(#clip0_103_2556)">
        <Rect x={0.666748} width={48} height={48} rx={8} fill="#F2F7FF" />
        <Path
          d="M13.976 18.05l22.623-.246c2.133-.023 3.877 1.456 3.91 3.316l.458 26.023c.033 1.86-1.658 3.377-3.792 3.4l-22.623.247c-2.133.023-3.877-1.456-3.91-3.316l-.458-26.024c-.033-1.86 1.658-3.376 3.792-3.4z"
          fill="url(#paint0_radial_103_2556)"
        />
        <Path
          d="M32.3 32.218a6.424 6.424 0 01-.47 2.527 6.52 6.52 0 01-1.427 2.155 6.71 6.71 0 01-2.168 1.452 6.934 6.934 0 01-5.173.056 6.836 6.836 0 01-2.218-1.404 6.645 6.645 0 01-1.503-2.122 6.426 6.426 0 01-.089-5.044 6.525 6.525 0 011.428-2.155 6.714 6.714 0 012.168-1.453c.814-.34 1.69-.52 2.577-.53.888-.01 1.77.152 2.596.474.826.322 1.58.8 2.218 1.405A6.644 6.644 0 0131.74 29.7c.354.796.544 1.651.56 2.517z"
          fill="#fff"
        />
        <Path
          d="M25.485 29.087a2.661 2.661 0 00-1.857.776 2.53 2.53 0 00-.47 2.93c.174.343.422.644.728.883a5.92 5.92 0 00-2.04 1.084 5.748 5.748 0 00-1.45 1.77 6.803 6.803 0 002.364 1.75c.91.406 1.899.611 2.897.601a6.876 6.876 0 002.875-.664 6.675 6.675 0 002.301-1.8 5.86 5.86 0 00-1.51-1.74 6.019 6.019 0 00-2.08-1.04c.297-.245.535-.551.696-.897.161-.346.241-.723.235-1.103a2.564 2.564 0 00-.806-1.815 2.697 2.697 0 00-1.883-.735z"
          fill="#3982DD"
        />
        <Path
          d="M18.621 41.438c-.182.002-.354.13-.48.355a1.73 1.73 0 00-.185.848c.005.317.083.62.216.843.132.223.31.347.491.345l14.157-.154c.182-.002.355-.13.48-.356a1.73 1.73 0 00.186-.847 1.747 1.747 0 00-.216-.843c-.133-.223-.31-.347-.492-.345l-14.157.154zM22.006 45.387c-.194.002-.377.13-.51.356-.133.226-.205.53-.2.848.006.317.089.62.23.843.14.223.328.347.522.345l7.53-.083c.194-.002.378-.13.51-.355.134-.226.206-.531.2-.848a1.662 1.662 0 00-.229-.843c-.14-.223-.329-.347-.523-.345l-7.53.082z"
          fill="#fff"
        />
        <Path
          d="M22.497 10.827c-1.125.012-2.015.905-1.996 2.002l.158 8.952 9.392-.102-.158-8.952c-.019-1.097-.94-1.97-2.065-1.958l-5.33.058z"
          fill="url(#paint1_radial_103_2556)"
        />
        <Path d="M20.488 22.205l9.748-.106" stroke="#fff" />
        <Path
          d="M27.256 15.849a1.905 1.905 0 01-.563 1.388c-.183.184-.401.33-.643.43a2.04 2.04 0 01-1.534.018 2.025 2.025 0 01-.657-.417 1.97 1.97 0 01-.446-.63 1.918 1.918 0 01.397-2.135 2.044 2.044 0 012.835-.03c.382.363.602.857.61 1.376z"
          fill="#fff"
        />
      </G>
      <Defs>
        <RadialGradient
          id="paint0_radial_103_2556"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(-25.08388 29.9288 -27.71876 -23.23161 38.18 19.919)"
        >
          <Stop stopColor="#9DC2FF" />
          <Stop offset={1} stopColor="#3D7FEB" />
        </RadialGradient>
        <RadialGradient
          id="paint1_radial_103_2556"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="rotate(128.002 11.409 12.63) scale(13.1177 11.2682)"
        >
          <Stop stopColor="#FFE0B9" />
          <Stop offset={1} stopColor="#CD9A58" />
        </RadialGradient>
        <ClipPath id="clip0_103_2556">
          <Rect x={0.666748} width={48} height={48} rx={8} fill="#fff" />
        </ClipPath>
      </Defs>
    </Svg>
  )
}

export default CardSVG
